import apiHandler from "../core/apiHandler";

// 📌 Todas las rutas estarán bajo /api/client/sidebar
const sidebarApi = apiHandler("client/sidebar");

export default sidebarApi;
